import React, { useState, useEffect } from 'react'
import { 
  Modal, ModalHeader, ModalBody,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from 'reactstrap'
import { isEmpty, maxBy } from 'lodash'
import { toast } from 'react-toastify'

import Lang from 'Lang/General'

const GenerateLink = props => {
  const [ pages, setPages ] = useState( [] )
  const [ isPagesDropdownOpen, setIsPagesDropdownOpen ] = useState( false )

  useEffect( () => {
    if( props.showGenerateLinkModalForm.values ){
      setPages( 
        Array.from(
          { length: maxBy( props.showGenerateLinkModalForm.values, 'page' ).page }, 
          ( _, index ) => index + 1
        ) 
      )
    }
  }, [ props.showGenerateLinkModalForm ] )

  return(
    <Modal
      isOpen={ !isEmpty( props.showGenerateLinkModalForm ) }>
      <ModalHeader toggle={ () => props.onChangeDigitalOrderFormHOC( 'showGenerateLinkModalForm', {} ) }>
        { Lang[ 'COPY_SPECIFIC_PAGE_URL' ][ props.data.languageReducer.lang ] }
      </ModalHeader>
      <ModalBody>
        <style>
          {`
            .pages-dropdown-toggle {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              height: calc(1.5em + 0.75rem + 2px);
              padding: 0.375rem 0.75rem;
              font-size: 1rem;
              font-weight: 400;
              line-height: 1.5;
              color: #495057 !important;
              background-color: #fff;
              background-clip: padding-box;
              border: 1px solid #ced4da !important;
              border-radius: 0.25rem;
              transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
              background-color: #ffffff00 !important;
              text-transform: none !important;
            }

            .pages-dropdown-toggle:hover {
              color: #495057 !important;
              background-color: #ffffff00 !important;
            }
          `}
        </style>
        <Dropdown 
          isOpen={ isPagesDropdownOpen }
          toggle={ () => setIsPagesDropdownOpen( !isPagesDropdownOpen ) } >
          <DropdownToggle 
            caret
            className='form-control pages-dropdown-toggle'>
            { Lang[ 'SELECT_A_PAGE_NUMBER' ][ props.data.languageReducer.lang ] }
          </DropdownToggle>
          <DropdownMenu>
            {
              pages.map( page => (
                <DropdownItem 
                  key={ page } 
                  onClick={ () => {
                    let tmp = ''
                    if( window.location.host.indexOf( 'localhost' ) !== -1 ) {
                      tmp = 'http://localhost:4510'
                    } else if( window.location.host.indexOf( 'staging' ) !== -1 ) {
                      tmp = 'https://cockpit-staging.proof-point-suite.com'
                    } else if( window.location.host.indexOf( 'aciso' ) !== -1 ) {
                      tmp = 'https://adminportal.aciso-suite.com'
                    } else if( window.location.host.indexOf( 'proof-point' ) !== -1 ) {
                      tmp = 'https://adminportal.proof-point-suite.com'
                    }
                    navigator.clipboard.writeText( `${ tmp }/#/dashboard/digital-order-form/listings-form/${ props.showGenerateLinkModalForm.id }/page/${ page }` )
                    toast.success( Lang[ 'COPY_URL_SUCCESS' ][ props.data.languageReducer.lang ] )
                  }} >
                  { page }
                </DropdownItem>
              ))
            }
          </DropdownMenu>
        </Dropdown>
      </ModalBody>
    </Modal>
  )
}

export default GenerateLink 